import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';


@Injectable({ providedIn: 'root' })
export class JwtInterceptor implements HttpInterceptor {


    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
        const currentUser = null;
        let isLoggedIn = false;
        if(currentUser) {
            const currentUserData = JSON.parse(currentUser);
            isLoggedIn = currentUserData.access_token;
            const isApiUrl = false;
            if (isLoggedIn && isApiUrl) {
                request = request.clone({
                    setHeaders: {
                        Authorization: `Bearer ${currentUserData.access_token}`
                    }
                });
            }
        }
        return next.handle(request);
    }
}
